export default "__VITE_ASSET__Bbt1bayy__"